import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    lastUpdatedText: {
        color: 'white',
        margin: '0 70px',
        padding: '8px 20px',
        border: '1px solid white',
        borderRadius: '5px',
        whiteSpace: 'nowrap',

        [theme.breakpoints.down('lg')]: {
            border: 'none',
            padding: '5px 0',
            display: 'flex',
            fontSize: '14px',
            justifyContent: 'center',
        },
    },
    lastUpdatedTextWrapper: {
        [theme.breakpoints.down('lg')]: {
            width: '100%',
            backgroundColor: 'hsl(197deg 62% 51%)',
        },
    },
}));
